import React, { useEffect } from 'react'
import { useRouter } from 'next/router'

import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import PsPenetapanKirim from 'app/KinerjaPSPage/pages/penetapan/kirim/Index'
import PageGuardPengawas from 'app/KinerjaPSPage/components/PageGuardPengawas'
import {
  PENGELOLAAN_KINERJA_NOT_FOUND_PATH,
  PENGELOLAAN_KINERJA_PS_PATH,
} from 'app/KinerjaShared/constants/path'
import { PageGuardPenetapan } from 'app/KinerjaPSPage/components/PageGuardPenetapan'
import { useIsPrior2025 } from 'app/KinerjaShared/hooks/useIsPrior2025'

import type { KinerjaApp } from 'types/kinerja-layout'
import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    context: NextPageContext,
    toggle: TToggleKeyValuePair
  ) => {
    const enabled =
      (toggle?.['kinerja-ps-enabled'] &&
        toggle?.['kinerja-ps-penetapan-enabled']) ||
      false

    if (!enabled) {
      return {
        redirect: {
          destination: PENGELOLAAN_KINERJA_NOT_FOUND_PATH,
          permanent: false,
        },
      }
    }
  },
})

const Page: KinerjaApp = () => {
  const isPrior2025 = useIsPrior2025()
  const router = useRouter()

  useEffect(() => {
    if (!isPrior2025) {
      router.replace(`${PENGELOLAAN_KINERJA_PS_PATH}/penetapan/kepala-sekolah`)
    }
  }, [isPrior2025, router])

  return (
    <PageGuardPengawas accessibleByKepalaDinas>
      <PageGuardPenetapan>
        <PsPenetapanKirim />
      </PageGuardPenetapan>
    </PageGuardPengawas>
  )
}

Page.Layout = KinerjaLayout

Page.layoutOpts = {
  hasHeader: true,
  centered: true,
}

export default Page
